import React from "react";
import { Modal } from "react-bootstrap";

function CommonModal(props) {
  const {
    show,
    handleClose,
    title = "",
    children,
    size,
    isLoader = false,
    customTitleClass = "",
    customDialogModal = "",
    customContentClass = "",
    customClass = "",
    backdrop = true,
    customStyle = null,
    enforceFocus = true,
    customBodyClass = "",
    center = false,
    customBackdropClassname = "",
    autoFocus = true,
    scrollable = false,
    showCloseButton = false,
  } = props;
  return isLoader ? (
    <></>
  ) : (
    <Modal
      animation={false}
      size={size}
      show={show}
      centered={center}
      onHide={handleClose}
      backdrop={backdrop}
      autoFocus={autoFocus}
      enforceFocus={enforceFocus}
      dialogClassName={customDialogModal}
      contentClassName={customContentClass}
      backdropClassName={customBackdropClassname}
      style={customStyle}
      scrollable={scrollable}
      className={customClass}
    >
      {title && (
        <Modal.Header closeButton={showCloseButton ? false : true} className="pop-header">
          <div className="flex items-center">
            <Modal.Title className={customTitleClass}>{title}</Modal.Title>
          </div>
          {showCloseButton && (
            <div className="flex items-center cursor-pointer " onClick={handleClose}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M6 18L18 6M6 6L18 18"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          )}
        </Modal.Header>
      )}
      <Modal.Body className={customBodyClass}>{children}</Modal.Body>
    </Modal>
  );
}

export default CommonModal;
